import { createSlice } from '@reduxjs/toolkit';
import { MARKERS_INITIAL_STATE } from './markers.constants';
import {
  addMarkerToMarkersDataReducer,
  removeMarkerFromMarkersDataReducer,
  setMarkersDataReducer,
  updateMarkerInMarkersDataReducer,
} from './markers.reducers';

const markersSlice = createSlice({
  name: 'markers',
  initialState: MARKERS_INITIAL_STATE,
  reducers: {
    setMarkersData: setMarkersDataReducer,
    addMarkerToMarkersData: addMarkerToMarkersDataReducer,
    updateMarkerInMarkersData: updateMarkerInMarkersDataReducer,
    removeMarkerFromMarkersData: removeMarkerFromMarkersDataReducer,
  },
  extraReducers: () => {},
});

export const {
  setMarkersData,
  addMarkerToMarkersData,
  updateMarkerInMarkersData,
  removeMarkerFromMarkersData,
} = markersSlice.actions;

export default markersSlice.reducer;
